export const FETCHING_DEVICES_ORDERS_LIST = '@@toyota/FETCHING_DEVICES_ORDERS_LIST';
export const FETCHED_DEVICES_ORDERS_LIST = '@@toyota/FETCHED_DEVICES_ORDERS_LIST';
export const FETCHED_DEVICES_ORDERS_LIST_FAILED = '@@toyota/FETCHED_DEVICES_ORDERS_LIST_FAILED';
export const UPDATING_DEVICE_ORDER = '@@toyota/UPDATING_DEVICE_ORDER';
export const UPDATED_DEVICE_ORDER = '@@toyota/UPDATED_DEVICE_ORDER';
export const UPDATED_DEVICE_ORDER_FAILED = '@@toyota/UPDATED_DEVICE_ORDER_FAILED';
export const CREATING_SATELLITAL_DEVICE_ORDER = '@@toyota/CREATING_SATELLITAL_DEVICE_ORDER';
export const CREATED_SATELLITAL_DEVICE_ORDER = '@@toyota/CREATED_SATELLITAL_DEVICE_ORDER';
export const CREATED_SATELLITAL_DEVICE_ORDER_FAILED = '@@toyota/CREATED_SATELLITAL_DEVICE_ORDER_FAILED';
export const DOWNLOADING_DEVICE_ORDERS_LIST = '@@toyota/DOWNLOADING_DEVICE_ORDERS_LIST';
export const DOWNLOADED_DEVICE_ORDERS_LIST = '@@toyota/DOWNLOADED_DEVICE_ORDERS_LIST';
export const DOWNLOADED_DEVICE_ORDERS_LIST_FAILED = '@@toyota/DOWNLOADED_DEVICE_ORDERS_LIST_FAILED';
export const RESTORE_DEVICES_ORDERS_PAGE = '@@toyota/RESTORE_DEVICES_ORDERS_PAGE';
export const CHANGE_DEVICES_ORDERS_DATE = '@@toyota/CHANGE_DEVICES_ORDERS_DATE';
export const CHANGE_DEVICES_ORDERS_DATE_END = '@@toyota/CHANGE_DEVICES_ORDERS_DATE_END';
export const CHANGE_DEVICES_ORDERS_PAGE = '@@toyota/CHANGE_DEVICES_ORDERS_PAGE';
export const RESIZE_DEVICES_ORDERS_PAGE = '@@toyota/RESIZE_DEVICES_ORDERS_PAGE';
export const CHANGE_CHASSIS_MARKED = '@@toyota/CHANGE_CHASSIS_MARKED';
export const CHANGE_ORDERS_MARKED = '@@toyota/CHANGE_ORDERS_MARKED';
export const CLEAN_DEVICES_ORDERS_LIST = '@@toyota/CLEAN_DEVICES_ORDERS_LIST';
export const CLEAR_SATELLITAL_DEVICE_CHASSIS_FAILED = '@@toyota/CLEAR_SATELLITAL_DEVICE_CHASSIS_FAILED';
export const UPDATING_SATELLITAL_DEVICE_ORDER = '@@toyota/UPDATING_SATELLITAL_DEVICE_ORDER';
export const UPDATED_SATELLITAL_DEVICE_ORDER = '@@toyota/UPDATED_SATELLITAL_DEVICE_ORDER';
export const UPDATED_SATELLITAL_DEVICE_ORDER_FAILED = '@@toyota/UPDATED_SATELLITAL_DEVICE_ORDER_FAILED';
export const CLEAR_SATELLITAL_DEVICE = '@@toyota/CLEAR_SATELLITAL_DEVICE';
export const FETCHING_REQUESTS_DEVICE_LIST = '@@toyota/FETCHING_REQUESTS_DEVICE_LIST';
export const FETCHED_REQUESTS_DEVICE_LIST = '@@toyota/FETCHED_REQUESTS_DEVICE_LIST';
export const FETCHED_REQUESTS_DEVICE_LIST_FAILED =
  '@@toyota/FETCHED_REQUESTS_DEVICE_LIST_FAILED';
export const ADDING_REQUESTS_DEVICE = '@@toyota/ADDING_REQUESTS_DEVICE';
export const ADDED_REQUESTS_DEVICE = '@@toyota/ADDED_REQUESTS_DEVICE';
export const ADDED_REQUESTS_DEVICE_FAILED = '@@toyota/ADDED_REQUESTS_DEVICE';
export const FETCHING_REQUEST_ID = '@@toya/FETCHING_REQUEST_ID';
export const FETCHED_REQUEST_ID = '@@toyota/FETCHED_REQUEST_ID';
export const FETCHED_REQUEST_ID_FAILED = '@@toyota/FETCHED_REQUEST_ID_FAILED';
export const CLEAR_REQUESTS_DEVICE_LIST = '@@toyota/CLEAR_REQUESTS_DEVICE_LIST';
export const FETCHING_REQUEST_DEVICE_DETAIL =
  '@@toyota/FETCHING_REQUEST_DEVICE_DETAIL';
export const FETCHED_REQUEST_DEVICE_DETAIL = '@@toyota/FETCHED_REQUEST_DEVICE_DETAIL';
export const FETCHED_REQUEST_DEVICE_DETAIL_FAILED = '@@toyota/FETCHED_REQUEST_DEVICE_DETAIL_FAILED';
export const FETCHING_REQUESTS_CHASSIS_DEVICE_LIST =
  '@@toyota/FETCHING_REQUESTS_CHASSIS_DEVICE_LIST';
export const FETCHED_REQUESTS_CHASSIS_DEVICE_LIST =
  '@@toyota/FETCHED_REQUESTS_CHASSIS_DEVICE_LIST';
export const FETCHED_REQUESTS_CHASSIS_DEVICE_LIST_FAILED =
  '@@toyota/FETCHED_REQUESTS_CHASSIS_DEVICE_LIST_FAILED';
export const FETCHING_DESISNTALLATION_MOTIVES_LIST =
  '@@toyota/FETCHING_DESISNTALLATION_MOTIVES_LIST';
export const FETCHED_DESISNTALLATION_MOTIVES_LIST =
  '@@toyota/FETCHED_DESISNTALLATION_MOTIVES_LIST';
export const FETCHED_DESISNTALLATION_MOTIVES_LIST_FAILED = '@@toyota/FETCHED_DESISNTALLATION_MOTIVES_LIST_FAILED';

// vehicleInfoList
export const FETCHING_VEHICLES_INFO_LIST_BY_SEARCH = '@@toyota/FETCHING_VEHICLES_INFO_LIST_BY_SEARCH';
export const FETCHED_VEHICLES_INFO_LIST_BY_SEARCH =
  '@@toyota/FETCHED_VEHICLES_INFO_LIST_BY_SEARCH';
export const FETCHED_VEHICLES_INFO_LIST_BY_SEARCH_FAILED =
  '@@toyota/FETCHED_VEHICLES_INFO_LIST_BY_SEARCH_FAILED';
export const CLEAR_VEHICLES_INFO_LIST_BY_SEARCH = '@@toyota/CLEAR_VEHICLES_INFO_LIST_BY_SEARCH';
export const FETCHING_DEVICES_STOCK = '@@toyota/FETCHING_DEVICES_STOCK';
export const FETCHED_DEVICES_STOCK = '@@toyota/FETCHED_DEVICES_STOCK';
export const FETCHED_DEVICES_STOCK_FAILED = '@@toyota/FETCHED_DEVICES_STOCK_FAILED';
